import { useEffect } from "react";
import loadingSpinner from "../../assests/page/loading-spinner.svg";
import stripeIcon from "../../assests/page/Stripe_icon-square.svg";
import { motion } from "framer-motion";
import LinkBank from "./linkBank";
import { getUserCustodyBanks } from "../../services/contracts/clientContract";
import SuccessPopup from "./success";
import AddFunds from "./addFunds";
import { ethers } from "ethers";
import { currenciesToFiat, errorToast } from "../../utils/constants";
import PaymentMethods from "./paymentMethods";
import { useGetCustodianDetails } from "../../hooks/managers";
import SelectBank from "./selectBank";
import useNetworkStore from "../../store/networkStore";
import useUserStore from "../../store/userSlice";
import { chainDetails } from "../../utils/config";
import WitdrawFunds from "./withdrawFunds";
import {
  moneyHubClientUserAccessToken,
  moneyHubConnectLink,
  moneyHubCreateUser,
  moneyHubFetchAllConnections,
  moneyHubPaymentLink,
  moneyHubUserAccounts,
} from "../../utils/helpers/moneyhub";
import {
  blinkActiveBanks,
  blinkConnectLink,
  blinkCreatePayment,
  blinkPaymentStatus,
  blinkUserAccounts,
} from "../../utils/helpers/blink";
import {
  createStripeAccount,
  createStripeOnBoardLink,
  createVerifiedCashIssueRequest,
} from "../../utils/helpers/stripe";
import {
  iniciadorActiveBanks,
  iniciadorConnectLink,
  iniciadorUserAccounts,
} from "../../utils/helpers/iniciador";
import { useTranslation } from "react-i18next";

const LoadingPopup = (props) => {
  const { t } = useTranslation();
  const { chainId, provider, signer } = useNetworkStore();

  const { userAddress, userId } = useUserStore();

  const { allCountries } = props.generalDataProps;

  const {
    getCustodianDetailsData,
    getCustodianDetailsLoading,
    getCustodianDetailsError,
  } = useGetCustodianDetails(
    allCountries,
    props.action === "card-payment"
      ? props?.selectedCurrency?.tokenName
      : props.action === "moneyhub-payment"
        ? "MONEYHUB"
        : props.action === "blink-payment"
          ? "BLINK"
          : "",
    chainDetails[chainId].spotCustodian || "", //pass a filter address to use always for single custodian processing all payments??
  );

  useEffect(() => {
    const getMoneyHubConnectLink = async () => {
      if (signer) {
        await getUserCustodyBanks(chainId, userAddress, signer).then(
          async (res) => {
            if (res) {
              if (
                res.length > 0 &&
                res?.find(
                  (bnk) =>
                    ethers.utils
                      .parseBytes32String(bnk?.currency)
                      ?.toLowerCase() === "MONEYHUB"?.toLowerCase(),
                )
              ) {
                const userIdRaw = (res?.find(
                  (bnk) =>
                    ethers.utils
                      .parseBytes32String(bnk?.currency)
                      ?.toLowerCase() === "MONEYHUB"?.toLowerCase(),
                )).account;
                const userId = ethers.utils.parseBytes32String(userIdRaw);

                if (props.isReconnect) {
                  await moneyHubConnectLink(userId).then((_res) => {
                    if (_res) {
                      window.location.href = _res;
                    } else {
                      errorToast(
                        "Oops Something went wrong",
                        "Unexpected error try again later.",
                      );
                      props.setPopupContent(
                        <LinkBank
                          setShowPopup={props.setShowPopup}
                          setPopupContent={props.setPopupContent}
                          setPopupContentPosition={
                            props.setPopupContentPosition
                          }
                          setFavouriteClicked={props.setFavouriteClicked}
                          currentStep="2"
                          generalDataProps={props.generalDataProps}
                          countryList={props.countryList}
                        />,
                      );
                      props.setPopupContentPosition("flex-end");
                      props.setShowPopup(true);
                    }
                  });
                } else {
                  await moneyHubClientUserAccessToken(userId).then(
                    async (authTk) => {
                      if (authTk) {
                        await moneyHubUserAccounts(authTk).then(
                          async (_res) => {
                            if (_res && _res.length > 0) {
                              const allMoneyHubConnections =
                                await moneyHubFetchAllConnections();
                              const resFmt = _res.map((acct) => {
                                return {
                                  ...acct,
                                  iconUrl: allMoneyHubConnections.find(
                                    (cnt) =>
                                      cnt?.id?.toLowerCase() ===
                                      acct?.providerId,
                                  )?.iconUrl,
                                };
                              });
                              props.setPopupContent(
                                <LinkBank
                                  setShowPopup={props.setShowPopup}
                                  setPopupContent={props.setPopupContent}
                                  setPopupContentPosition={
                                    props.setPopupContentPosition
                                  }
                                  setFavouriteClicked={
                                    props.setFavouriteClicked
                                  }
                                  currentStep="3"
                                  bankList={resFmt}
                                  generalDataProps={props.generalDataProps}
                                  countryList={props.countryList}
                                  buttonAction="link-bank"
                                />,
                              );
                              props.setPopupContentPosition("flex-end");
                              props.setShowPopup(true);
                            } else if (_res && _res.length === 0) {
                              await moneyHubConnectLink(userId).then((_res) => {
                                if (_res) {
                                  window.location.href = _res;
                                } else {
                                  errorToast(
                                    "Oops Something went wrong",
                                    "Unexpected error try again later.",
                                  );
                                  props.setPopupContent(
                                    <LinkBank
                                      setShowPopup={props.setShowPopup}
                                      setPopupContent={props.setPopupContent}
                                      setPopupContentPosition={
                                        props.setPopupContentPosition
                                      }
                                      setFavouriteClicked={
                                        props.setFavouriteClicked
                                      }
                                      currentStep="2"
                                      generalDataProps={props.generalDataProps}
                                      countryList={props.countryList}
                                      buttonAction="link-bank"
                                    />,
                                  );
                                  props.setPopupContentPosition("flex-end");
                                  props.setShowPopup(true);
                                }
                              });
                            } else {
                              errorToast(
                                "Oops Something went wrong",
                                "Unexpected error try again later.",
                              );
                              props.setPopupContent(
                                <LinkBank
                                  setShowPopup={props.setShowPopup}
                                  setPopupContent={props.setPopupContent}
                                  setPopupContentPosition={
                                    props.setPopupContentPosition
                                  }
                                  setFavouriteClicked={
                                    props.setFavouriteClicked
                                  }
                                  currentStep="2"
                                  generalDataProps={props.generalDataProps}
                                  countryList={props.countryList}
                                  buttonAction="link-bank"
                                />,
                              );
                              props.setPopupContentPosition("flex-end");
                              props.setShowPopup(true);
                            }
                          },
                        );
                      } else {
                        errorToast(
                          "Oops Something went wrong",
                          "Unexpected error try again later.",
                        );
                        props.setPopupContent(
                          <LinkBank
                            setShowPopup={props.setShowPopup}
                            setPopupContent={props.setPopupContent}
                            setPopupContentPosition={
                              props.setPopupContentPosition
                            }
                            setFavouriteClicked={props.setFavouriteClicked}
                            currentStep="2"
                            generalDataProps={props.generalDataProps}
                            countryList={props.countryList}
                            buttonAction="link-bank"
                          />,
                        );
                        props.setPopupContentPosition("flex-end");
                        props.setShowPopup(true);
                      }
                    },
                  );
                }
              } else {
                await moneyHubCreateUser(userAddress).then(async (res) => {
                  if (res) {
                    const userId = res.userId;
                    await moneyHubConnectLink(userId).then((_res) => {
                      if (_res) {
                        window.location.href = _res;
                      } else {
                        errorToast(
                          "Oops Something went wrong",
                          "Unexpected error try again later.",
                        );
                        props.setPopupContent(
                          <LinkBank
                            setShowPopup={props.setShowPopup}
                            setPopupContent={props.setPopupContent}
                            setPopupContentPosition={
                              props.setPopupContentPosition
                            }
                            setFavouriteClicked={props.setFavouriteClicked}
                            currentStep="2"
                            generalDataProps={props.generalDataProps}
                            countryList={props.countryList}
                            buttonAction="link-bank"
                          />,
                        );
                        props.setPopupContentPosition("flex-end");
                        props.setShowPopup(true);
                      }
                    });
                  } else {
                    errorToast(
                      "Oops Something went wrong",
                      "Error while creating moneyhub account. Try again  later",
                    );
                    props.setPopupContent(
                      <LinkBank
                        setShowPopup={props.setShowPopup}
                        setPopupContent={props.setPopupContent}
                        setPopupContentPosition={props.setPopupContentPosition}
                        setFavouriteClicked={props.setFavouriteClicked}
                        currentStep="2"
                        generalDataProps={props.generalDataProps}
                        countryList={props.countryList}
                        buttonAction="link-bank"
                      />,
                    );
                    props.setPopupContentPosition("flex-end");
                    props.setShowPopup(true);
                  }
                });
              }
            } else {
              errorToast(
                "Oops Something went wrong",
                "Unexpected error try again later.",
              );
              props.setPopupContent(
                <LinkBank
                  setShowPopup={props.setShowPopup}
                  setPopupContent={props.setPopupContent}
                  setPopupContentPosition={props.setPopupContentPosition}
                  setFavouriteClicked={props.setFavouriteClicked}
                  currentStep="2"
                  generalDataProps={props.generalDataProps}
                  countryList={props.countryList}
                  buttonAction="link-bank"
                />,
              );
              props.setPopupContentPosition("flex-end");
              props.setShowPopup(true);
            }
          },
        );
      }
    };

    const getMoneyhubAccounts = async () => {
      await moneyHubClientUserAccessToken(props.bankAccountId).then(
        async (authTk) => {
          if (authTk) {
            await moneyHubUserAccounts(authTk).then(async (_res) => {
              if (_res && _res.length > 0) {
                const allMoneyHubConnections =
                  await moneyHubFetchAllConnections();
                const resFmt = _res.map((acct) => {
                  return {
                    ...acct,
                    iconUrl: allMoneyHubConnections.find(
                      (cnt) => cnt?.id?.toLowerCase() === acct?.providerId,
                    )?.iconUrl,
                    custodyCurrencyType: "moneyhub",
                  };
                });
                props.setPopupContentPosition("flex-end");
                props.setPopupContent(
                  <SelectBank
                    setShowPopup={props.setShowPopup}
                    setPopupContent={props.setPopupContent}
                    setPopupContentPosition={props.setPopupContentPosition}
                    setFavouriteClicked={props.setFavouriteClicked}
                    bankList={resFmt}
                    generalDataProps={props.generalDataProps}
                    bankAccountId={props.bankAccountId}
                    amountInPence={props.amountInPence}
                    amount={props.amount}
                    backClickPopup={
                      props?.action?.includes("withdraw") ? (
                        <WitdrawFunds
                          setShowPopup={props.setShowPopup}
                          setPopupContent={props.setPopupContent}
                          setPopupContentPosition={
                            props.setPopupContentPosition
                          }
                          setFavouriteClicked={props.setFavouriteClicked}
                          selectedCurrency={props.selectedCurrency}
                          amount={props.amount}
                        />
                      ) : (
                        <AddFunds
                          setShowPopup={props.setShowPopup}
                          setPopupContent={props.setPopupContent}
                          setPopupContentPosition={
                            props.setPopupContentPosition
                          }
                          setFavouriteClicked={props.setFavouriteClicked}
                          generalDataProps={props.generalDataProps}
                          addFundsAction="add-funds"
                        />
                      )
                    }
                    selectedCurrency={props.selectedCurrency}
                    action={
                      props?.action?.includes("withdraw")
                        ? "bank-withdraw"
                        : "add-funds"
                    }
                    confirmationFunc={props.confirmationFunc}
                  />,
                );
              } else {
                props.setPopupContentPosition("flex-end");
                props.setPopupContent(
                  <SelectBank
                    setShowPopup={props.setShowPopup}
                    setPopupContent={props.setPopupContent}
                    setPopupContentPosition={props.setPopupContentPosition}
                    setFavouriteClicked={props.setFavouriteClicked}
                    bankList={[]}
                    generalDataProps={props.generalDataProps}
                    selectedCurrency={props.selectedCurrency}
                    bankAccountId={props.bankAccountId}
                    amountInPence={props.amountInPence}
                    amount={props.amount}
                    backClickPopup={
                      props?.action?.includes("withdraw") ? (
                        <WitdrawFunds
                          setShowPopup={props.setShowPopup}
                          setPopupContent={props.setPopupContent}
                          setPopupContentPosition={
                            props.setPopupContentPosition
                          }
                          setFavouriteClicked={props.setFavouriteClicked}
                          selectedCurrency={props.selectedCurrency}
                          amount={props.amount}
                        />
                      ) : (
                        <AddFunds
                          setShowPopup={props.setShowPopup}
                          setPopupContent={props.setPopupContent}
                          setPopupContentPosition={
                            props.setPopupContentPosition
                          }
                          setFavouriteClicked={props.setFavouriteClicked}
                          generalDataProps={props.generalDataProps}
                          addFundsAction="add-funds"
                        />
                      )
                    }
                    action={
                      props?.action?.includes("withdraw")
                        ? "bank-withdraw"
                        : "add-funds"
                    }
                  />,
                );
              }
            });
          } else {
            props.setPopupContentPosition("flex-end");
            props.setPopupContent(
              <SelectBank
                setShowPopup={props.setShowPopup}
                setPopupContent={props.setPopupContent}
                setPopupContentPosition={props.setPopupContentPosition}
                setFavouriteClicked={props.setFavouriteClicked}
                bankList={[]}
                generalDataProps={props.generalDataProps}
                selectedCurrency={props.selectedCurrency}
                amountInPence={props.amountInPence}
                amount={props.amount}
                backClickPopup={
                  props?.action?.includes("withdraw") ? (
                    <WitdrawFunds
                      setShowPopup={props.setShowPopup}
                      setPopupContent={props.setPopupContent}
                      setPopupContentPosition={props.setPopupContentPosition}
                      setFavouriteClicked={props.setFavouriteClicked}
                      selectedCurrency={props.selectedCurrency}
                      amount={props.amount}
                    />
                  ) : (
                    <AddFunds
                      setShowPopup={props.setShowPopup}
                      setPopupContent={props.setPopupContent}
                      setPopupContentPosition={props.setPopupContentPosition}
                      setFavouriteClicked={props.setFavouriteClicked}
                      generalDataProps={props.generalDataProps}
                      addFundsAction="add-funds"
                    />
                  )
                }
                action={
                  props?.action?.includes("withdraw")
                    ? "bank-withdraw"
                    : "add-funds"
                }
              />,
            );
          }
        },
      );
    };

    const getBlinkConnectLink = async () => {
      if (signer) {
        await getUserCustodyBanks(chainId, userAddress, signer).then(
          async (res) => {
            if (res) {
              if (
                res.length > 0 &&
                res?.find(
                  (bnk) =>
                    ethers.utils
                      .parseBytes32String(bnk?.currency)
                      ?.toLowerCase() === "BLINK"?.toLowerCase(),
                )
              ) {
                const userIdRaw = (res?.find(
                  (bnk) =>
                    ethers.utils
                      .parseBytes32String(bnk?.currency)
                      ?.toLowerCase() === "BLINK"?.toLowerCase(),
                )).account;
                const userId = ethers.utils.parseBytes32String(userIdRaw);
                if (props?.reconnect) {
                  await blinkConnectLink(userId, props.selectedBank?.id).then(
                    (lnk) => {
                      if (lnk) {
                        window.location.href = lnk;
                      } else {
                        errorToast(
                          "Oops Something went wrong",
                          "Unexpected error try again later.",
                        );
                        props.setPopupContent(
                          <LinkBank
                            setShowPopup={props.setShowPopup}
                            setPopupContent={props.setPopupContent}
                            setPopupContentPosition={
                              props.setPopupContentPosition
                            }
                            setFavouriteClicked={props.setFavouriteClicked}
                            currentStep="2"
                            generalDataProps={props.generalDataProps}
                            countryList={props.countryList}
                            buttonAction="link-bank"
                          />,
                        );
                        props.setPopupContentPosition("flex-end");
                        props.setShowPopup(true);
                      }
                    },
                  );
                } else {
                  await blinkUserAccounts(
                    userId,
                    props.selectedBank?.id,
                    true,
                  ).then(async (_res) => {
                    if (_res && _res?.accounts?.length > 0) {
                      const allBanks = await blinkActiveBanks();
                      const resFmt = _res?.accounts?.map((acct) => {
                        return {
                          ...acct,
                          iconUrl: allBanks.find(
                            (cnt) =>
                              cnt?.providerId?.toLowerCase() ===
                              _res?.providerId?.toLowerCase(),
                          )?.logo,
                          providerId: _res?.providerId,
                          userId,
                        };
                      });

                      props.setPopupContent(
                        <LinkBank
                          setShowPopup={props.setShowPopup}
                          setPopupContent={props.setPopupContent}
                          setPopupContentPosition={
                            props.setPopupContentPosition
                          }
                          setFavouriteClicked={props.setFavouriteClicked}
                          currentStep="3"
                          bankList={resFmt}
                          generalDataProps={props.generalDataProps}
                          isBlink={true}
                          selectedBank={props.selectedBank}
                          countryList={props.countryList}
                          buttonAction="link-bank"
                        />,
                      );
                      props.setPopupContentPosition("flex-end");
                      props.setShowPopup(true);
                    } else {
                      await blinkConnectLink(
                        userId,
                        props.selectedBank?.id,
                      ).then((lnk) => {
                        if (lnk) {
                          window.location.href = lnk;
                        } else {
                          errorToast(
                            "Oops Something went wrong",
                            "Unexpected error try again later.",
                          );
                          props.setPopupContent(
                            <LinkBank
                              setShowPopup={props.setShowPopup}
                              setPopupContent={props.setPopupContent}
                              setPopupContentPosition={
                                props.setPopupContentPosition
                              }
                              setFavouriteClicked={props.setFavouriteClicked}
                              currentStep="2"
                              generalDataProps={props.generalDataProps}
                              countryList={props.countryList}
                              buttonAction="link-bank"
                            />,
                          );
                          props.setPopupContentPosition("flex-end");
                          props.setShowPopup(true);
                        }
                      });
                    }
                  });
                }
              } else {
                const newId =
                  userId +
                  userAddress.slice(
                    userAddress?.length - 8,
                    userAddress?.length,
                  );
                await blinkConnectLink(
                  newId.slice(0, 31),
                  props.selectedBank?.id,
                ).then((lnk) => {
                  if (lnk) {
                    window.location.href = lnk;
                  } else {
                    errorToast(
                      "Oops Something went wrong",
                      "Unexpected error try again later.",
                    );
                    props.setPopupContent(
                      <LinkBank
                        setShowPopup={props.setShowPopup}
                        setPopupContent={props.setPopupContent}
                        setPopupContentPosition={props.setPopupContentPosition}
                        setFavouriteClicked={props.setFavouriteClicked}
                        currentStep="2"
                        generalDataProps={props.generalDataProps}
                        countryList={props.countryList}
                        buttonAction="link-bank"
                      />,
                    );
                    props.setPopupContentPosition("flex-end");
                    props.setShowPopup(true);
                  }
                });
              }
            } else {
              errorToast(
                "Oops Something went wrong",
                "Unexpected error try again later.",
              );
              props.setPopupContent(
                <LinkBank
                  setShowPopup={props.setShowPopup}
                  setPopupContent={props.setPopupContent}
                  setPopupContentPosition={props.setPopupContentPosition}
                  setFavouriteClicked={props.setFavouriteClicked}
                  currentStep="2"
                  generalDataProps={props.generalDataProps}
                  countryList={props.countryList}
                  buttonAction="link-bank"
                />,
              );
              props.setPopupContentPosition("flex-end");
              props.setShowPopup(true);
            }
          },
        );
      }
    };

    const getIniciadorConnectLink = async () => {
      if (signer) {
        await getUserCustodyBanks(chainId, userAddress, signer).then(
          async (res) => {
            if (res) {
              if (
                res.length > 0 &&
                res?.find(
                  (bnk) =>
                    ethers.utils
                      .parseBytes32String(bnk?.currency)
                      ?.toLowerCase() === "INICIADOR"?.toLowerCase(),
                )
              ) {
                const userIdRaw = (res?.find(
                  (bnk) =>
                    ethers.utils
                      .parseBytes32String(bnk?.currency)
                      ?.toLowerCase() === "INICIADOR"?.toLowerCase(),
                )).account;
                const userId = ethers.utils.parseBytes32String(userIdRaw);
                if (props?.reconnect) {
                  await iniciadorConnectLink(
                    userId,
                    props.selectedBank?.id,
                  ).then((lnk) => {
                    if (lnk?.link) {
                      window.location.href = lnk?.link;
                    } else {
                      errorToast(
                        "Oops Something went wrong",
                        "Unexpected error try again later.",
                      );
                      props.setPopupContent(
                        <LinkBank
                          setShowPopup={props.setShowPopup}
                          setPopupContent={props.setPopupContent}
                          setPopupContentPosition={
                            props.setPopupContentPosition
                          }
                          setFavouriteClicked={props.setFavouriteClicked}
                          currentStep="2"
                          generalDataProps={props.generalDataProps}
                          countryList={props.countryList}
                          buttonAction="link-bank"
                        />,
                      );
                      props.setPopupContentPosition("flex-end");
                      props.setShowPopup(true);
                    }
                  });
                } else {
                  await iniciadorUserAccounts(userId).then(async (_res) => {
                    if (_res && _res?.data.length > 0) {
                      const resFmt = _res?.data?.map((acct) => {
                        return {
                          ...acct,
                          iconUrl: _res?.iconUrl,

                          userId,
                        };
                      });

                      props.setPopupContent(
                        <LinkBank
                          setShowPopup={props.setShowPopup}
                          setPopupContent={props.setPopupContent}
                          setPopupContentPosition={
                            props.setPopupContentPosition
                          }
                          setFavouriteClicked={props.setFavouriteClicked}
                          currentStep="3"
                          bankList={resFmt}
                          generalDataProps={props.generalDataProps}
                          isBr={true}
                          selectedBank={props.selectedBank}
                          countryList={props.countryList}
                          buttonAction="link-bank"
                        />,
                      );
                      props.setPopupContentPosition("flex-end");
                      props.setShowPopup(true);
                    } else {
                      await iniciadorConnectLink(
                        userId,
                        props.selectedBank?.id,
                      ).then((lnk) => {
                        if (lnk?.link) {
                          window.location.href = lnk?.link;
                        } else {
                          errorToast(
                            "Oops Something went wrong",
                            "Unexpected error try again later.",
                          );
                          props.setPopupContent(
                            <LinkBank
                              setShowPopup={props.setShowPopup}
                              setPopupContent={props.setPopupContent}
                              setPopupContentPosition={
                                props.setPopupContentPosition
                              }
                              setFavouriteClicked={props.setFavouriteClicked}
                              currentStep="2"
                              generalDataProps={props.generalDataProps}
                              countryList={props.countryList}
                              buttonAction="link-bank"
                            />,
                          );
                          props.setPopupContentPosition("flex-end");
                          props.setShowPopup(true);
                        }
                      });
                    }
                  });
                }
              } else {
                const newId =
                  userId +
                  userAddress.slice(
                    userAddress?.length - 8,
                    userAddress?.length,
                  );
                await iniciadorConnectLink(
                  newId.slice(0, 31),
                  props.selectedBank?.id,
                ).then((lnk) => {
                  if (lnk?.link) {
                    window.location.href = lnk?.link;
                  } else {
                    errorToast(
                      "Oops Something went wrong",
                      "Unexpected error try again later.",
                    );
                    props.setPopupContent(
                      <LinkBank
                        setShowPopup={props.setShowPopup}
                        setPopupContent={props.setPopupContent}
                        setPopupContentPosition={props.setPopupContentPosition}
                        setFavouriteClicked={props.setFavouriteClicked}
                        currentStep="2"
                        generalDataProps={props.generalDataProps}
                        countryList={props.countryList}
                        buttonAction="link-bank"
                      />,
                    );
                    props.setPopupContentPosition("flex-end");
                    props.setShowPopup(true);
                  }
                });
              }
            } else {
              errorToast(
                "Oops Something went wrong",
                "Unexpected error try again later.",
              );
              props.setPopupContent(
                <LinkBank
                  setShowPopup={props.setShowPopup}
                  setPopupContent={props.setPopupContent}
                  setPopupContentPosition={props.setPopupContentPosition}
                  setFavouriteClicked={props.setFavouriteClicked}
                  currentStep="2"
                  generalDataProps={props.generalDataProps}
                  countryList={props.countryList}
                  buttonAction="link-bank"
                />,
              );
              props.setPopupContentPosition("flex-end");
              props.setShowPopup(true);
            }
          },
        );
      }
    };

    const getBlinkAccounts = async () => {
      await blinkUserAccounts(
        props.bankAccountId,
        props.selectedBank?.id,
        true,
      ).then(async (_res) => {
        if (_res && _res?.accounts?.length > 0) {
          const allBanks = await blinkActiveBanks();
          const resFmt = _res?.accounts?.map((acct) => {
            return {
              ...acct,
              iconUrl: allBanks.find(
                (cnt) =>
                  cnt?.providerId?.toLowerCase() ===
                  _res?.providerId?.toLowerCase(),
              )?.logo,
              custodyCurrencyType: "blink",
              providerId: _res?.providerId,
              userId: props.bankAccountId,
            };
          });

          props.setPopupContentPosition("flex-end");
          props.setPopupContent(
            <SelectBank
              setShowPopup={props.setShowPopup}
              setPopupContent={props.setPopupContent}
              setPopupContentPosition={props.setPopupContentPosition}
              setFavouriteClicked={props.setFavouriteClicked}
              bankList={resFmt}
              generalDataProps={props.generalDataProps}
              selectedCurrency={props.selectedCurrency}
              amountInPence={props.amountInPence}
              amount={props.amount}
              backClickPopup={
                props?.action?.includes("withdraw") ? (
                  <WitdrawFunds
                    setShowPopup={props.setShowPopup}
                    setPopupContent={props.setPopupContent}
                    setPopupContentPosition={props.setPopupContentPosition}
                    setFavouriteClicked={props.setFavouriteClicked}
                    selectedCurrency={props.selectedCurrency}
                    amount={props.amount}
                  />
                ) : (
                  <AddFunds
                    setShowPopup={props.setShowPopup}
                    setPopupContent={props.setPopupContent}
                    setPopupContentPosition={props.setPopupContentPosition}
                    generalDataProps={props.generalDataProps}
                    setFavouriteClicked={props.setFavouriteClicked}
                    addFundsAction="add-funds"
                  />
                )
              }
              bankAccountId={props.bankAccountId}
              action={
                props?.action?.includes("withdraw")
                  ? "bank-withdraw"
                  : "add-funds"
              }
              confirmationFunc={props.confirmationFunc}
            />,
          );
        } else {
          props.setPopupContentPosition("flex-end");
          props.setPopupContent(
            <SelectBank
              setShowPopup={props.setShowPopup}
              setPopupContent={props.setPopupContent}
              setPopupContentPosition={props.setPopupContentPosition}
              setFavouriteClicked={props.setFavouriteClicked}
              bankList={[]}
              generalDataProps={props.generalDataProps}
              selectedCurrency={props.selectedCurrency}
              bankAccountId={props.bankAccountId}
              amountInPence={props.amountInPence}
              amount={props.amount}
              backClickPopup={
                props?.action?.includes("withdraw") ? (
                  <WitdrawFunds
                    setShowPopup={props.setShowPopup}
                    setPopupContent={props.setPopupContent}
                    setPopupContentPosition={props.setPopupContentPosition}
                    setFavouriteClicked={props.setFavouriteClicked}
                    selectedCurrency={props.selectedCurrency}
                    amount={props.amount}
                  />
                ) : (
                  <AddFunds
                    setShowPopup={props.setShowPopup}
                    setPopupContent={props.setPopupContent}
                    setPopupContentPosition={props.setPopupContentPosition}
                    setFavouriteClicked={props.setFavouriteClicked}
                    generalDataProps={props.generalDataProps}
                    addFundsAction="add-funds"
                  />
                )
              }
              action={
                props?.action?.includes("withdraw")
                  ? "bank-withdraw"
                  : "add-funds"
              }
              confirmationFunc={props.confirmationFunc}
            />,
          );
        }
      });
    };

    const getOrCreateStripeAccount = async () => {
      if (signer) {
        await getUserCustodyBanks(chainId, userAddress, signer).then(
          async (res) => {
            if (res && !props?.action?.includes("card-accounts")) {
              if (
                res.length > 0 &&
                res?.find(
                  (bnk) =>
                    ethers.utils
                      .parseBytes32String(bnk?.currency)
                      ?.toLowerCase()
                      ?.split("-")[0] === props.countryCode?.toLowerCase() &&
                    ethers.utils
                      .parseBytes32String(bnk?.currency)
                      ?.toLowerCase()
                      ?.split("-")[1]?.length > 0,
                )
              ) {
                setTimeout(() => {
                  props.setPopupContent(
                    <SuccessPopup
                      setShowPopup={props.setShowPopup}
                      setPopupContent={props.setPopupContent}
                      setPopupContentPosition={props.setPopupContentPosition}
                      isCustom={true}
                      customTextHeader="Congratulations!"
                      customTextFooter={`You have successfully linked your Stripe account in ${props.countryCode}`}
                      setFavouriteClicked={props.setFavouriteClicked}
                      showButton={true}
                      buttonText="Go to payments"
                      buttonFunc={() => {
                        props.setPopupContent(
                          <AddFunds
                            setShowPopup={props.setShowPopup}
                            setPopupContent={props.setPopupContent}
                            setPopupContentPosition={
                              props.setPopupContentPosition
                            }
                            setFavouriteClicked={props.setFavouriteClicked}
                            customLoading={props.customLoading}
                            setCustomLoading={props.setCustomLoading}
                            generalDataProps={props.generalDataProps}
                            addFundsAction="add-funds"
                          />,
                        );
                        props.setPopupContentPosition("flex-end");
                        props.setShowPopup(true);
                      }}
                    />,
                  );
                  props.setPopupContentPosition("flex-end");
                  props.setShowPopup(true);
                }, 1000);
              } else {
                await createStripeAccount(
                  userAddress,
                  chainId,
                  props.countryCode,
                ).then(async (res) => {
                  if (res) {
                    await createStripeOnBoardLink(
                      res,
                      props.countryCode,
                      chainId,
                    ).then((_res) => {
                      if (_res) {
                        window.location.href = _res;
                      } else {
                        errorToast(
                          "Oops Something went wrong",
                          "Unexpected error try again later.",
                        );
                        props.setPopupContent(
                          <LinkBank
                            setShowPopup={props.setShowPopup}
                            setPopupContent={props.setPopupContent}
                            setPopupContentPosition={
                              props.setPopupContentPosition
                            }
                            setFavouriteClicked={props.setFavouriteClicked}
                            currentStep="2"
                            generalDataProps={props.generalDataProps}
                            countryList={props.countryList}
                            buttonAction="link-card"
                          />,
                        );
                        props.setPopupContentPosition("flex-end");
                        props.setShowPopup(true);
                      }
                    });
                  } else {
                    errorToast(
                      "Unable to create Stripe account",
                      "Stripe may not be supported in your country confirm your contry is supported and try again later.",
                    );
                    props.setPopupContent(
                      <LinkBank
                        setShowPopup={props.setShowPopup}
                        setPopupContent={props.setPopupContent}
                        setPopupContentPosition={props.setPopupContentPosition}
                        setFavouriteClicked={props.setFavouriteClicked}
                        currentStep="2"
                        generalDataProps={props.generalDataProps}
                        countryList={props.countryList}
                        buttonAction="link-card"
                      />,
                    );
                    props.setPopupContentPosition("flex-end");
                    props.setShowPopup(true);
                  }
                });
              }
            } else if (res && props?.action === "card-accounts-withdraw") {
              const allAccounts = res?.map((bnk) => {
                const currencyArr = ethers.utils
                  .parseBytes32String(bnk?.currency)
                  ?.split("-");
                const currency = currencyArr[1];
                const acct = ethers.utils.parseBytes32String(bnk?.account);
                if (currency?.length > 0 && bnk?.account) {
                  return {
                    currency: currency?.toUpperCase(),
                    country: currencyArr[0],
                    name: "Stripe",
                    logo: stripeIcon,
                    id: acct,
                    acct,
                  };
                } else {
                  return null;
                }
              });

              props.setPopupContent(
                <SelectBank
                  setShowPopup={props.setShowPopup}
                  setPopupContent={props.setPopupContent}
                  setPopupContentPosition={props.setPopupContentPosition}
                  setFavouriteClicked={props.setFavouriteClicked}
                  bankList={allAccounts?.filter((acct) => acct !== null)}
                  generalDataProps={props.generalDataProps}
                  amount={props.amount}
                  backClickPopup={
                    <WitdrawFunds
                      setShowPopup={props.setShowPopup}
                      setPopupContent={props.setPopupContent}
                      setPopupContentPosition={props.setPopupContentPosition}
                      setFavouriteClicked={props.setFavouriteClicked}
                      selectedCurrency={props.selectedCurrency}
                      amount={props.amount}
                    />
                  }
                  selectedCurrency={props.selectedCurrency}
                  action="card-withdraw"
                  confirmationFunc={props.confirmationFunc}
                />,
              );
              props.setPopupContentPosition("flex-end");
              props.setShowPopup(true);
            } else if (!res) {
              errorToast(
                "Oops Something went wrong",
                "Unexpected error try again later.",
              );
              props.setPopupContent(
                <LinkBank
                  setShowPopup={props.setShowPopup}
                  setPopupContent={props.setPopupContent}
                  setPopupContentPosition={props.setPopupContentPosition}
                  setFavouriteClicked={props.setFavouriteClicked}
                  currentStep="2"
                  generalDataProps={props.generalDataProps}
                  countryList={props.countryList}
                  buttonAction="link-card"
                />,
              );
              props.setPopupContentPosition("flex-end");
              props.setShowPopup(true);
            }
          },
        );
      }
    };

    const handleCardPayment = async () => {
      if (
        getCustodianDetailsData?.custodians?.length > 0 &&
        chainId &&
        userAddress
      ) {
        await createVerifiedCashIssueRequest(
          chainId,
          userAddress,
          props.selectedCurrency?.amount,
          "CH", //default supported stripe country code to trigger stripe payment
          props.notDefaultCustodian
            ? props?.custodians[0]?.accountId
            : getCustodianDetailsData?.custodians[0]?.accountId,
          props.selectedCurrency?.tokenName?.toLowerCase()?.startsWith("vc")
            ? props.selectedCurrency?.tokenName?.toUpperCase().replace("VC", "")
            : currenciesToFiat[
                props.selectedCurrency?.tokenName?.toUpperCase()
              ],
          props.selectedCurrency?.tokenAddress,
        ).then((_res) => {
          if (_res) {
            props.setPopupContentPosition("flex-end");
            props.setPopupContent(
              <PaymentMethods
                setShowPopup={props.setShowPopup}
                setPopupContent={props.setPopupContent}
                setPopupContentPosition={props.setPopupContentPosition}
                setFavouriteClicked={props.setFavouriteClicked}
                selectedCurrency={props.selectedCurrency}
                generalDataProps={props.generalDataProps}
                paymentSecret={_res.client_secret}
                showPaymentPortal={true}
                paymentType={props.paymentType}
                custodians={getCustodianDetailsData?.custodians}
                custodianDetails={
                  props.notDefaultCustodian
                    ? props?.custodians[0]
                    : getCustodianDetailsData?.custodians[0]
                }
              />,
            );
            props.setShowPopup(true);
          } else {
            errorToast(
              "Oops Something went wrong",
              "Verify payment amount and try again later.",
            );
            props.setPopupContentPosition("flex-end");
            props.setPopupContent(
              <PaymentMethods
                setShowPopup={props.setShowPopup}
                setPopupContent={props.setPopupContent}
                setPopupContentPosition={props.setPopupContentPosition}
                setFavouriteClicked={props.setFavouriteClicked}
                selectedCurrency={props.selectedCurrency}
                generalDataProps={props.generalDataProps}
              />,
            );
            props.setShowPopup(true);
          }
        });
      } else if (getCustodianDetailsData?.custodians?.length === 0) {
        errorToast(
          "Oops Something went wrong",
          "No Verified custodian for selected currency.",
        );
        props.setPopupContentPosition("flex-end");
        props.setPopupContent(
          <PaymentMethods
            setShowPopup={props.setShowPopup}
            setPopupContent={props.setPopupContent}
            setPopupContentPosition={props.setPopupContentPosition}
            setFavouriteClicked={props.setFavouriteClicked}
            selectedCurrency={props.selectedCurrency}
            generalDataProps={props.generalDataProps}
          />,
        );
        props.setShowPopup(true);
      }
    };

    const handleMoneyHubPayment = async () => {
      if (
        getCustodianDetailsData?.custodians?.length > 0 &&
        chainId &&
        userAddress &&
        props.requestPayload
      ) {
        await moneyHubClientUserAccessToken(
          getCustodianDetailsData?.custodians[0]?.accountId,
        ).then(async (authTk) => {
          if (authTk) {
            await moneyHubUserAccounts(authTk).then(async (_res) => {
              if (_res && _res?.length > 0) {
                const {
                  payer_id,
                  payer_bank_id,
                  payer_bank_account_id,
                  payer_bank_type,
                  payer_bank_connection_id,
                  payer_name,
                  payer_email,
                  amount_in_pence,
                  context,
                } = props.requestPayload;
                const accountToUse = _res?.find(
                  (bnk) =>
                    bnk?.providerId === payer_bank_id &&
                    bnk?.type === payer_bank_type,
                )
                  ? _res?.find(
                      (bnk) =>
                        bnk?.providerId === payer_bank_id &&
                        bnk?.type === payer_bank_type,
                    )
                  : _res?.find((bnk) => bnk?.type === payer_bank_type)
                    ? _res?.find((bnk) => bnk?.type === payer_bank_type)
                    : _res[0];

                await moneyHubPaymentLink(
                  payer_id,
                  payer_bank_id,
                  payer_bank_account_id,
                  payer_bank_connection_id,
                  payer_name,
                  payer_email,
                  amount_in_pence,
                  getCustodianDetailsData?.custodians[0]?.accountId,
                  accountToUse?.id,
                  context,
                ).then((lnk) => {
                  if (lnk?.id && lnk?.redirectParams) {
                    window.location.href = lnk?.redirectParams?.authUrl;
                  } else if (!lnk) {
                    errorToast(
                      "Oops Something went wrong",
                      "Error while creating payment request",
                    );
                    props.setPopupContentPosition("flex-end");
                    props.setPopupContent(
                      <PaymentMethods
                        setShowPopup={props.setShowPopup}
                        setPopupContent={props.setPopupContent}
                        setPopupContentPosition={props.setPopupContentPosition}
                        setFavouriteClicked={props.setFavouriteClicked}
                        selectedCurrency={props.selectedCurrency}
                        generalDataProps={props.generalDataProps}
                      />,
                    );
                    props.setShowPopup(true);
                  }
                });
              }
            });
          }
        });
      } else if (getCustodianDetailsData?.custodians?.length === 0) {
        errorToast(
          "Oops Something went wrong",
          "No Verified custodian for selected currency.",
        );
        props.setPopupContentPosition("flex-end");
        props.setPopupContent(
          <PaymentMethods
            setShowPopup={props.setShowPopup}
            setPopupContent={props.setPopupContent}
            setPopupContentPosition={props.setPopupContentPosition}
            setFavouriteClicked={props.setFavouriteClicked}
            selectedCurrency={props.selectedCurrency}
            generalDataProps={props.generalDataProps}
          />,
        );
        props.setShowPopup(true);
      }
    };

    const handleBlinkPayment = async () => {
      if (
        getCustodianDetailsData?.custodians?.length > 0 &&
        chainId &&
        userAddress &&
        props.requestPayload
      ) {
        await blinkUserAccounts(
          getCustodianDetailsData?.custodians[0]?.accountId,
          props.selectedBank?.providerId,
          true,
        ).then(async (_res) => {
          if (_res && _res?.accounts?.length > 0) {
            const accountToUse = _res?.accounts?.find(
              (acct) =>
                acct?.account?.type === payer_account?.type &&
                acct?.account?.identification !== payer_account?.identification,
            );

            const {
              provider_id,
              payer_id,
              payer_account,
              amount,
              amount_currency_symbol,
            } = props.requestPayload;

            await blinkCreatePayment(
              provider_id,
              payer_id,
              payer_account,
              amount,
              amount_currency_symbol,
              accountToUse?.account,
              accountToUse?.accountOwner,
              getCustodianDetailsData?.custodians[0]?.countryCode,
            ).then(async (res) => {
              const paymentId = res?.location?.replace("/payments/", "");
              const providerId = res?.provider;
              await blinkPaymentStatus(payer_id, providerId, paymentId).then(
                (_res) => {
                  if (_res?.statusCode?.startsWith("ACCP")) {
                    props.setPopupContentPosition("flex-end");
                    props.setPopupContent(
                      <SuccessPopup
                        setShowPopup={props.setShowPopup}
                        setPopupContent={props.setPopupContent}
                        setPopupContentPosition={props.setPopupContentPosition}
                        isCustom={true}
                        customTextHeader="Payment Successfull!"
                        customTextFooter={`Our Custodian will review your payment and top up equivalent ${props.selectedCurrency?.toUpperCase()}`}
                        setFavouriteClicked={props.setFavouriteClicked}
                        showButton={true}
                        buttonText="Go to payments"
                        generalDataProps={props.generalDataProps}
                        buttonFunc={() => {
                          props.setPopupContent(
                            <AddFunds
                              setShowPopup={props.setShowPopup}
                              setPopupContent={props.setPopupContent}
                              setPopupContentPosition={
                                props.setPopupContentPosition
                              }
                              customLoading={props.customLoading}
                              setCustomLoading={props.setCustomLoading}
                              generalDataProps={props.generalDataProps}
                              addFundsAction="add-funds"
                            />,
                          );
                          props.setPopupContentPosition("flex-end");
                          props.setShowPopup(true);
                        }}
                      />,
                    );
                    props.setShowPopup(true);
                  }
                },
              );
            });
          } else {
            const {
              provider_id,
              payer_id,
              payer_account,
              amount,
              amount_currency_symbol,
            } = props.requestPayload;

            await blinkCreatePayment(
              provider_id,
              payer_id,
              payer_account,
              amount,
              amount_currency_symbol,
              { type: "IBAN", identification: "CH5604835012345678009" },
              "Validor Ibanus",
              "CH",
            ).then(async (res) => {
              const paymentId = res?.location?.replace("/payments/", "");
              const providerId = res?.provider;
              await blinkPaymentStatus(payer_id, providerId, paymentId).then(
                (_res) => {
                  if (_res?.statusCode?.startsWith("ACCP")) {
                    props.setPopupContentPosition("flex-end");
                    props.setPopupContent(
                      <SuccessPopup
                        setShowPopup={props.setShowPopup}
                        setPopupContent={props.setPopupContent}
                        setPopupContentPosition={props.setPopupContentPosition}
                        isCustom={true}
                        customTextHeader="Payment Successfull!"
                        customTextFooter={`Our Custodian will review your payment and top up equivalent ${props.selectedCurrency?.toUpperCase()}`}
                        setFavouriteClicked={props.setFavouriteClicked}
                        showButton={true}
                        buttonText="Go to payments"
                        generalDataProps={props.generalDataProps}
                        buttonFunc={() => {
                          props.setPopupContent(
                            <AddFunds
                              setShowPopup={props.setShowPopup}
                              setPopupContent={props.setPopupContent}
                              setPopupContentPosition={
                                props.setPopupContentPosition
                              }
                              customLoading={props.customLoading}
                              setCustomLoading={props.setCustomLoading}
                              generalDataProps={props.generalDataProps}
                              addFundsAction="add-funds"
                            />,
                          );
                          props.setPopupContentPosition("flex-end");
                          props.setShowPopup(true);
                        }}
                      />,
                    );
                    props.setShowPopup(true);
                  }
                },
              );
            });
          }
        });
      } else if (getCustodianDetailsData?.custodians?.length === 0) {
        errorToast(
          "Oops Something went wrong",
          "No Verified custodian for selected currency.",
        );
        props.setPopupContentPosition("flex-end");
        props.setPopupContent(
          <PaymentMethods
            setShowPopup={props.setShowPopup}
            setPopupContent={props.setPopupContent}
            setPopupContentPosition={props.setPopupContentPosition}
            setFavouriteClicked={props.setFavouriteClicked}
            selectedCurrency={props.selectedCurrency}
            generalDataProps={props.generalDataProps}
          />,
        );
        props.setShowPopup(true);
      }
    };

    if (
      props.action === "moneyhub-connect" &&
      userAddress &&
      chainId > 0 &&
      signer
    ) {
      getMoneyHubConnectLink();
    }

    if (props.action?.startsWith("moneyhub-acounts") && props.bankAccountId) {
      getMoneyhubAccounts();
    }

    if (
      props.action === "blink-connect" &&
      userAddress &&
      userId &&
      chainId > 0 &&
      signer
    ) {
      getBlinkConnectLink();
    }

    if (
      props.action === "iniciador-connect" &&
      userAddress &&
      userId &&
      chainId > 0 &&
      signer
    ) {
      getIniciadorConnectLink();
    }

    if (
      props.action?.startsWith("blink-acounts") &&
      props.bankAccountId &&
      props.selectedBank?.id
    ) {
      getBlinkAccounts();
    }

    if (
      props.action === "stripe-connect" &&
      props.countryCode &&
      userAddress &&
      chainId > 0 &&
      signer
    ) {
      getOrCreateStripeAccount();
    }

    if (
      props.action?.startsWith("card-accounts") &&
      userAddress &&
      chainId > 0 &&
      signer
    ) {
      getOrCreateStripeAccount();
    }

    if (
      props.action === "card-payment" &&
      userAddress &&
      chainId > 0 &&
      signer
    ) {
      handleCardPayment();
    }

    if (
      props.action === "moneyhub-payment" &&
      userAddress &&
      chainId > 0 &&
      signer
    ) {
      handleMoneyHubPayment();
    }

    if (
      props.action === "blink-payment" &&
      userAddress &&
      chainId > 0 &&
      signer
    ) {
      handleBlinkPayment();
    }
  }, [
    chainId,
    getCustodianDetailsData?.custodians,
    props,
    provider,
    signer,
    userAddress,
    userId,
  ]);

  return (
    <>
      {!props.isCustom && (
        <div
          style={
            props.mobileScreen
              ? {
                  alignContent: "center",
                  justifyContent: "center",
                  width: "100%",
                }
              : props.customWidth
                ? { width: `${props.customWidth}px` }
                : {
                    alignContent: "center",
                    justifyContent: "center",
                  }
          }
          className="success-popup-content-container"
        >
          <div className="success-popup-content">
            <motion.img
              height="100px"
              width="100px"
              src={loadingSpinner}
              alt={t("common.loading")}
              animate={{
                rotate: 360,
                scale: [1, 1.5, 1],
              }}
              transition={{
                duration: 2,
                repeat: Infinity,
                ease: "linear",
              }}
            />
            <div className="success-popup-content-text">
              <p
                id="loading-popup-title"
                className="success-popup-content-text-header"
              >
                Searching...
              </p>
              <p
                id="loading-popup-label"
                className="success-popup-content-text-footer"
              >
                Looking for broker accounts linked with your phone number.
              </p>
            </div>
          </div>
        </div>
      )}
      {props.isCustom && (
        <div
          style={
            props.mobileScreen
              ? {
                  alignContent: "center",
                  justifyContent: "center",
                  width: "100%",
                }
              : props.customWidth
                ? { width: `${props.customWidth}%` }
                : {
                    alignContent: "center",
                    justifyContent: "center",
                  }
          }
          className="success-popup-content-container"
        >
          <div className="success-popup-content">
            <motion.img
              height="100px"
              width="100px"
              src={loadingSpinner}
              alt={t("common.loading")}
              animate={{
                rotate: 360,
                scale: [1, 1.5, 1],
              }}
              transition={{
                duration: 2,
                repeat: Infinity,
                ease: "linear",
              }}
            />
            <div className="success-popup-content-text">
              <p className="success-popup-content-text-header">
                {props.customTextHeader}
              </p>
              <p className="success-popup-content-text-footer">
                {props.customTextFooter}
              </p>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default LoadingPopup;
